import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment';
import { DatastoreService, ConfigService, CommonFunctionsService, NotificationStoreService } from 'src/app/services/index';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private dataStore: DatastoreService,
    private configService: ConfigService,
    private commonFunctionsService: CommonFunctionsService,
    private notifStore: NotificationStoreService
  ) { }
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    return true
  }

  async getConfig() {
    let config = await this.configService.getConfig();
    const companyConfig = JSON.stringify(config);
    sessionStorage.setItem("config", companyConfig);
    this.commonFunctionsService.setConfig(companyConfig);
    this.dataStore.config = companyConfig;
    this.notifStore.onsessionUpdate(true);
    return config;
  }

}
